import styled, { keyframes } from 'styled-components';

const cubicBezier = `cubic-bezier(0.23, 1, 0.32, 1)`;
const onEnter = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

export const StyledSVG = styled('svg')`
  animation: ${onEnter} 0.5s ${cubicBezier};
  position: absolute;
  top: 0;
  left: 0;
`;
